import { render } from "./TalentDashboardComponent.vue?vue&type=template&id=ea14f23c"
import script from "./TalentDashboardComponent.vue?vue&type=script&lang=js"
export * from "./TalentDashboardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__